import { render, staticRenderFns } from "./technician_page.vue?vue&type=template&id=34c84dd2&scoped=true"
import script from "./technician_page.vue?vue&type=script&lang=js"
export * from "./technician_page.vue?vue&type=script&lang=js"
import style0 from "./technician_page.vue?vue&type=style&index=0&id=34c84dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c84dd2",
  null
  
)

export default component.exports